import React from "react";

const UnlockIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.076"
      height="24.886"
      viewBox="0 0 19.076 24.886"
      fill={fill}
    >
      <path
        id="Subtraction_4"
        data-name="Subtraction 4"
        d="M22809.635-9718.111h-16.2a1.442,1.442,0,0,1-1.437-1.442v-11.038a1.442,1.442,0,0,1,1.438-1.442h1.77l0-.006h1.783l0,.006h9.094v-4.334a4.71,4.71,0,0,0-4.547-4.849,4.709,4.709,0,0,0-4.545,4.849v.7h-1.785v-.7a6.492,6.492,0,0,1,6.33-6.629,6.49,6.49,0,0,1,6.326,6.629v4.334h1.77a1.445,1.445,0,0,1,1.443,1.442v11.038A1.445,1.445,0,0,1,22809.635-9718.111Zm-8.1-10.248a1.845,1.845,0,0,0-1.842,1.844,1.831,1.831,0,0,0,1.172,1.712v3.011h1.334v-3.011h.006a1.85,1.85,0,0,0,1.174-1.712A1.845,1.845,0,0,0,22801.539-9728.359Z"
        transform="translate(-22792.002 9742.997)"
      />
    </svg>
  );
};

export default UnlockIcon;
